import {
  AUTH_ROUTES,
  ROUTE_PATHS,
  isAdminDashboardRoute,
  isUserDashboardRoute,
} from './routes'

export function resolveRouteAccess(route, session = {}) {
  const user = session.user || null
  const isSignedIn = Boolean(session.token && user)
  const isAdmin = user?.role === 'admin'

  if (AUTH_ROUTES.has(route) && isSignedIn) {
    return {
      authorized: false,
      redirectTo: isAdmin ? ROUTE_PATHS.admin : ROUTE_PATHS.dashboard,
    }
  }

  if (isAdminDashboardRoute(route)) {
    if (!isSignedIn) {
      return { authorized: false, redirectTo: ROUTE_PATHS.login }
    }

    if (!isAdmin) {
      return { authorized: false, redirectTo: ROUTE_PATHS.dashboard }
    }
  }

  if (isUserDashboardRoute(route) && !isSignedIn) {
    return { authorized: false, redirectTo: ROUTE_PATHS.login }
  }

  return { authorized: true, redirectTo: null }
}
